import { take } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import * as FlatServices from '@medsurf/flat-services';
import { MediaLibraryComponent } from '../media-library.component';

@Component({
    selector: 'medsurf-media-library-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './media-library-modal.component.html',
    styleUrls: ['./media-library-modal.component.scss'],
    standalone: false
})
export class MediaLibraryModalComponent {
	@Input() set mediaId(value: string | null | undefined) {
		this.#mediaId = value;
		if (this.#mediaId) {
			this.mediaAuthorFacade.mediaById$(this.#mediaId).pipe(take(1)).subscribe((media) => {
				this.media = media;
			})
		} else {
      this.media = undefined;
    }
	}
	get mediaId() {
		return this.#mediaId;
	}
	@Input() label: string;
	@Input() allowedTypes?: FlatModels.MediaEntityModels.MediaType[];

	@Output() mediaChange = new EventEmitter<string | null>();
	
	#mediaId: string | null | undefined;
	media: FlatModels.MediaEntityModels.MediaEntityType | undefined;
	getImageMenuItems = () => {
		return [
			{
				label: !this.media ? this.translate.instant('global.image_choose') : this.translate.instant('global.image_exchange'),
				icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.MEDIA_VISUAL,
				command: () => this.openLibrary()
			},
			{
				label: this.translate.instant('global.image_delete'),
				disabled: !this.media,
				icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.TIMES,
				styleClass: FlatModels.ButtonDesignModels.ButtonDesignClass.MENU_DANGER,
				command: () => this.removeMedia()
			}
		] satisfies MenuItem[];
	};
	readonly FlatModels = FlatModels;
	
	constructor(protected mediaAuthorFacade: FlatFacades.MediaAuthorFacade,
	            protected mediaControlService: FlatServices.MediaControlService,
	            private translate: TranslateService,
	            private dialogService: DialogService) {
	}

  openLibrary() {
    const dialogRef = this.dialogService.open(MediaLibraryComponent, {
      header: this.translate.instant("global.image_choose"),
      data: {
        isModal: true,
        multiple: false,
		selected: this.mediaId ? { id: this.mediaId } : undefined,
        allowedTypes: this.allowedTypes
      } satisfies FlatModels.ModalAuthorModels.MediaLibraryModalData,
      dismissableMask: true,
      width: '90%',
      height: '90%',
      maximizable: true,
      rtl: true,
    });
    dialogRef.onClose.subscribe(media => {
      if (media && media.id !== this.mediaId) {
        this.mediaId = media.id;
        this.mediaChange.emit(media.id)
      }
    });
  }

  removeMedia() {
    this.mediaChange.emit(null);
  }
}
